import React from 'react';
import { Link } from 'react-router-dom';

const BuildBetterPrivacy = () => {
  return (
    <div className="min-h-screen bg-cream-100 relative">
      <div className="grain-overlay" aria-hidden="true"></div>

      <header className="pt-16 md:pt-24 pb-12 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="animate-on-load animate-fade-in-up">
            <Link
              to="/build-better"
              className="font-body text-ink-muted hover:text-ink text-sm uppercase tracking-widest mb-6 inline-block transition-colors"
            >
              ← Build Better
            </Link>
            <p className="font-body text-ink-muted text-sm uppercase tracking-widest mb-4">
              Last updated: March 9, 2026
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink tracking-tight">
              Privacy Policy
            </h1>
            <p className="font-body text-ink-muted text-lg mt-4">Build Better</p>
          </div>
        </div>
      </header>

      <main className="px-6 md:px-12 pb-24">
        <div className="max-w-3xl mx-auto">
          <div className="editorial-divider mb-12"></div>

          <article className="font-body text-ink-light leading-relaxed text-lg animate-on-load animate-fade-in-up animate-delay-200">
            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              The short version
            </h2>
            <p className="mb-6">
              Build Better does not collect literally any data from you. No personal data, no
              analytics, no tracking, no telemetry, and no crash reporting.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">Details</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                <strong className="font-medium text-ink">No data collection.</strong> We do not
                collect any personal information or usage data.
              </li>
              <li>
                <strong className="font-medium text-ink">No third-party tracking.</strong> Build
                Better does not include analytics SDKs, ad SDKs, or tracking pixels.
              </li>
              <li>
                <strong className="font-medium text-ink">No accounts.</strong> There is no login,
                sign-up, or profile system.
              </li>
              <li>
                <strong className="font-medium text-ink">Local-only storage.</strong> Favorites and
                reminder settings are stored locally on your device and are not transmitted.
              </li>
              <li>
                <strong className="font-medium text-ink">No data sales or sharing.</strong> Since
                we collect no data, there is nothing to sell or share.
              </li>
            </ul>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              Changes to this policy
            </h2>
            <p className="mb-6">
              If this policy changes, this page will be updated. Because Build Better is designed
              to collect no data, significant changes are not expected.
            </p>
          </article>

          <div className="editorial-divider my-12"></div>
        </div>
      </main>

      <footer className="border-t border-cream-300 bg-cream-200/50">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-12">
          <p className="font-body text-center text-ink-muted text-sm tracking-wide">
            © {new Date().getFullYear()} Teddy Marchildon
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BuildBetterPrivacy;
